import { render, staticRenderFns } from "./MenuDialog.vue?vue&type=template&id=94bf727a"
import script from "./MenuDialog.vue?vue&type=script&lang=js"
export * from "./MenuDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuDialog.vue?vue&type=style&index=0&id=94bf727a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports